// Pre-filled answer slots mapping
export const PreFilledAnswerSlots = {
  Length1: 0, // Content length = 1
  Length2To3: 0, // Content length = 2 to 3
  Length4To5: 1, // Content length = 4 to 5
  Length6To7: 1, // Content length = 6 to 7
  Length8To9: 2, // Content length = 8 to 9
  Length10To11: 3, // Content length = 10 to 11
  Length12To13: 4, // Content length = 12 to 13
  Length14To15: 4, // Content length = 14 to 15
  Length16To17: 5, // Content length = 16 to 17
  Length18OrMore: -1, // Placeholder for dynamic calculation
};

// Utility function to calculate pre-filled slots for content length >= 18
export function calculatePreFilledSlots(contentLength: number): number {
  if (contentLength >= 18) {
    return Math.ceil(contentLength * 0.3); // 30% rounded up
  }
  throw new Error('Content length must be 18 or more for dynamic calculation.');
}

// Main function to get the pre-filled slots based on content length
export function getPreFilledAnswerSlots(contentLength: number): number {
  if (contentLength === 1) {
    return PreFilledAnswerSlots.Length1;
  } else if (contentLength >= 2 && contentLength <= 3) {
    return PreFilledAnswerSlots.Length2To3;
  } else if (contentLength >= 4 && contentLength <= 5) {
    return PreFilledAnswerSlots.Length4To5;
  } else if (contentLength >= 6 && contentLength <= 7) {
    return PreFilledAnswerSlots.Length6To7;
  } else if (contentLength >= 8 && contentLength <= 9) {
    return PreFilledAnswerSlots.Length8To9;
  } else if (contentLength >= 10 && contentLength <= 11) {
    return PreFilledAnswerSlots.Length10To11;
  } else if (contentLength >= 12 && contentLength <= 13) {
    return PreFilledAnswerSlots.Length12To13;
  } else if (contentLength >= 14 && contentLength <= 15) {
    return PreFilledAnswerSlots.Length14To15;
  } else if (contentLength >= 16 && contentLength <= 17) {
    return PreFilledAnswerSlots.Length16To17;
  } else if (contentLength >= 18) {
    return calculatePreFilledSlots(contentLength);
  } else {
    throw new Error('Invalid content length.');
  }
}

// Function to get random pre-filled indexes
export function getPreFilledIndexes(contentLength: number): number[] {
  const preFilledSlots = getPreFilledAnswerSlots(contentLength);

  if (preFilledSlots === 0) {
    return []; // No pre-filled indexes
  }

  const indexes: number[] = [];
  while (indexes.length < preFilledSlots) {
    const randomIndex = Math.floor(Math.random() * contentLength);

    // Ensure no duplicate indexes
    if (!indexes.includes(randomIndex)) {
      indexes.push(randomIndex);
    }
  }

  return indexes.sort((a, b) => a - b); // Optional: Sort the indexes in ascending order
}

export const getCandidateAnswerSlot = (
  contentLength: number,
  useColor: boolean | undefined,
): number => {
  if (useColor) {
    if (contentLength <= 3) {
      return 1;
    } else if (contentLength <= 5) {
      return 2;
    } else if (contentLength <= 7) {
      return 4;
    } else if (contentLength <= 9) {
      return 5;
    } else if (contentLength <= 11) {
      return 7;
    } else if (contentLength <= 13) {
      return 8;
    } else if (contentLength <= 15) {
      return 10;
    } else if (contentLength <= 17) {
      return 12;
    } else if (contentLength <= 20) {
      return 14;
    } else if (contentLength <= 25) {
      return 16;
    } else if (contentLength <= 30) {
      return 18;
    } else {
      return 22;
    }
  } else {
    return Math.min(9, Math.max(1, Math.floor(contentLength * 0.5)));
  }
};
